import { Badge as AntBadge } from 'antd'
import type { ComponentProps } from 'react'

type AntBadgeProps = ComponentProps<typeof AntBadge>

export interface AppBadgeProps extends AntBadgeProps {}

export const AppBadge = (props: AppBadgeProps) => <AntBadge {...props} />

export const AppBadgeRibbon = AntBadge.Ribbon
